module.exports = __webpack_public_path__ + "img/middle-east-lg.7873235f.svg";